module.exports = __webpack_public_path__ + "media/post-listing-block-5-overlay-wide.9fe2407d.webp";